export default "__VITE_ASSET__bc9d8711__"